import { Component, OnInit, ChangeDetectorRef, Input, ChangeDetectionStrategy, computed, input, inject } from '@angular/core';
import { merge } from 'rxjs';
import { PaintDirective } from '../../paint.directive';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { IBrandCard } from '../../types';
import { ImageFallbackDirective } from '../../image-fallback.directive';
import { BucketPipe } from "../../bucket.pipe";
import { AuthService } from '../../auth.service';

@Component({
  selector: 'brand-card',
  templateUrl: './brand-card.component.html',
  styleUrls: ['./brand-card.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PaintDirective, RouterLink, MatIconModule, ImageFallbackDirective, BucketPipe]
})
export class BrandCardComponent {
  auth = inject(AuthService);

  brand = input.required<IBrandCard>();
  small = input<boolean>(false);

  can_view = computed(() => {
    const brand = this.brand();

    return brand?.tags?.map(tag => tag.plans).flat().some(plan => this.auth.userViewPlans().includes(plan)) || false;
  });

  base_tags = computed(() => {
    const brand = this.brand();
    const view_plans = this.auth.userViewPlans() || [];

    const tags = brand.tags || [];

    return tags.sort((a,b) => {
      const aPlan = view_plans.includes(a.plan) ? view_plans.indexOf(a.plan) : 1000;
      const bPlan = view_plans.includes(b.plan) ? view_plans.indexOf(b.plan) : 1000;

      if(aPlan == bPlan){
        const aValue = a.tag_value_calculated;
        const bValue = b.tag_value_calculated;

        if(aValue == bValue){
          const aSavings = a.savings;
          const bSavings = b.savings;
          return aSavings > bSavings ? -1 : 1;
        }

        return aValue > bValue ? -1 : 1;
      }

      return aPlan > bPlan ? 1 : -1;
    }).filter((tag, index, arr) => arr.findIndex(t => t.tag_value == tag.tag_value && t.plan == tag.plan && t.upgrade == tag.upgrade) == index);
  });

}
